export default __webpack_public_path__ + "static/media/flag-pt.c18997fd.svg";